module.exports = __webpack_public_path__ + "img/T2B_rc_19.46953269.png";